import styled from 'styled-components';
import { Paragraph } from '../../atoms/Paragraph/Paragraph';
import { Icon } from '../../atoms/Icon/Icon';

export const StyledCheckmark = styled(Icon.Checkmark)``;

export const StyledText = styled(Paragraph)`
  margin-left: 0.625rem;
`;

export const StyledLabel = styled.label<{ $isDisabled?: boolean }>`
  position: relative;
  display: inline-block;
  cursor: ${({ $isDisabled }) => $isDisabled && 'not-allowed'};
  color: ${({ $isDisabled, theme }) => $isDisabled && theme.color.grey};
`;

export const StyledInput = styled.input`
  cursor: ${({ disabled }) => disabled && 'not-allowed'};
`;
